import { useEffect, useRef, useState } from "react";
import styleSheet from "./style.module.scss";
import Comments from "../comments";
import FilesList from "../file-list";
import OrbInput from "../../../../shared/forms/orb-input";
import { useMutation } from "@tanstack/react-query";
import orbitService from "../../services/orbit-service";
import { useParams } from "react-router";
import SyIcon from "../../../../shared/components/sy-icon";
import { tabDetails } from "./file-comment-config";
import planetService from "../../services/planet-service";
import citizenService from "../../services/citizen-service";
import CitizensList from "../citizens-list";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { getOrbitDetails } from "../../../../feature/orbit-slice";
import OrbPopover from "../../../../shared/components/orb-popover";
import React from "react";
import { OrbToast } from "../../../../utils/orb-toast";
import { getCookie, setCookie } from "../../../../utils/cookie";

type Props = {};

const FilesCommentsManage = (props: any) => {
  const { updateData, getCitizenData, citizensData, comment = false } = props;
  const [view, setView] = useState<any>(1);
  const [commentData, setCommentData] = useState<any>({});
  const [fileData, setFileData] = useState<any>([]);
  const { t } = useTranslation();
  const { planetId, orbitId } = useParams();
  const inputRef = useRef<HTMLInputElement>(null);
  const scrollRef = useRef<HTMLDivElement>(null);
  const orbitSlice = useSelector(getOrbitDetails);
  const languageRef = useRef(null);
  const languageId = "simple-popover";
  const [openPopOver, setOpenPopOver] = useState(false);
  const [isChecked, setIsChecked] = useState(true);
  const [selectedPlanets, setSelectedPlanets] = useState<number[]>([]);
  const [planetDetails, setPlanetDetails] = useState<number[]>([]);

  const handleOpenPopOver = () => {
    setOpenPopOver(!openPopOver);
  };
  const handleClosePopover = () => {
    setOpenPopOver(!openPopOver);
  };
  const onTabClick = (tabId: any) => {
    setView(tabId);
  };
  const visibleTabs = comment ? tabDetails.slice(0, 1) : tabDetails;
  const commentInputRef = useRef<any>(null);

  const onClickSend = (e: any) => {
    if (!comment) {
      const payload: any = {
        orb_id : orbitId,
        pro_id: planetId,
        message: e,
      };
      addComment(payload);
    } else {
      if (selectedPlanets.length) {
        const payload: any = {
          orb_id: orbitSlice.selectOrbit,
          pro_ids: selectedPlanets,
          message: e,
        };
        addOrbitComment(payload);
      } else {
        OrbToast(t("select_at_least_one_planet"), "top-right", "short", "default");
      }
    }
  };

  const { mutate: addComment } = useMutation({
    mutationFn: planetService.addComment,
    onSuccess(data, variables, context) {
      if (commentInputRef.current) {
        commentInputRef.current.value = "";
      }
      getCommentData();
    },
  });

  const { mutate: addOrbitComment } = useMutation({
    mutationFn: planetService.addOrbitComment,
    onSuccess(data, variables, context) {
      if (commentInputRef.current) {
        commentInputRef.current.value = "";
      }
      getCommentData();
    },
  });

  const getCommentData = () => {
    let payload: any = {
     orb_id : orbitId,
      pro_id: planetId,
    };
    if (comment) {
      delete payload.pro_id;
      payload.orb_id = orbitSlice.selectOrbit;
    }
    getComments(payload);
    if (comment) {
      getOrbitPlanet(payload);
    }
  };
  const { mutate: getComments } = useMutation({
    mutationFn: planetService.getComments,
    onSuccess(data, variables, context) {
      setCommentData(data.data);
      setTimeout(() => {
        if (scrollRef.current) {
          scrollRef.current!.scrollTop = scrollRef.current!.scrollHeight;
        }
      }, 300);
    },
  });
const { mutate: getOrbitPlanet } = useMutation({
  mutationFn: planetService.getOrbitPlanet,
  onSuccess(data) {
    setPlanetDetails(data.data);

    const proIds = data.data.map((item: any) => item.pro_id);


     setSelectedPlanets(proIds);
    // const cookieProId = getCookie("pro_ids");

    // console.log(cookieProId,'cookieProId')

    // if (cookieProId) {
    //   // cookie exists → restore selection
    //   try {
    //     setSelectedPlanets(JSON.parse(cookieProId));
    //   } catch {
    //     setSelectedPlanets([]);
    //   }
    // } else {
    //   // no cookie → default to all planets
    //   setSelectedPlanets(proIds);
    //   setCookie("pro_ids", JSON.stringify(proIds));
    // }
  },
});


  const openFile = () => {
    inputRef.current?.click();
  };

  const fileValueChange = (file: any) => {
    let val = {};

    const formData = new FormData();
    formData.append("file", file.target.files[0]);
    val = {
      id: planetId,
      value: formData,
    };
    addDoc(val);
  };

  const { mutate: addDoc } = useMutation({
    mutationFn: planetService.addDoc,
    onSuccess(data, variables, context) {
      getFileData();
    },
  });

  const getFileData = () => {
    const payload = {
      pro_id: planetId,
    };
    getDoc(payload);
  };

  const deleteCitizen = (data: any) => {
    const payload = {
      opr_id: data.opr_id,
    };
    removeCitizen(payload);

  };
  const { mutate: removeCitizen } = useMutation({
    mutationFn: planetService.removeCitizen,
    onSuccess(data, variables, context) {
      getCitizenData();
       updateData(false);
    },
  });

  const deleteDoc = (data: any) => {
    const payload = {
      dis_id: data.dis_id,
    };
    deletDoc(payload);
  };

  const { mutate: deletDoc } = useMutation({
    mutationFn: planetService.deletDoc,
    onSuccess(data, variables, context) {
      getFileData();
    },
  });

  const { mutate: getDoc } = useMutation({
    mutationFn: planetService.getDoc,
    onSuccess(data, variables, context) {
      const file = data.data.reverse();
      setFileData(file);
      updateData(true);
    },
  });

  useEffect(() => {
    if (view === 1) {
      getCommentData();
    } else if (view === 2) {
      getFileData();
    } else {
      getCitizenData();
    }
    setTimeout(() => {
      if (scrollRef.current) {
        scrollRef.current!.scrollTop = scrollRef.current!.scrollHeight;
      }
    }, 300);
  }, [view]);

  // useEffect(() => {
  //   const loadData = async () => {
  //     if (view === 1) await getCommentData();
  //     else if (view === 2) await getFileData();
  //     else await getCitizenData();

  //     // Scroll after content update
  //     requestAnimationFrame(() => {
  //       if (scrollRef.current) {
  //         scrollRef.current.scrollTop = scrollRef.current.scrollHeight;
  //       }
  //     });
  //   };
  //   loadData();
  // }, [view]);

  const onClickPlanet = (id: number) => {
    setSelectedPlanets((prev) => {
      if (prev.includes(id)) {
          // setCookie("pro_ids", JSON.stringify(prev.filter((planetId) => planetId !== id)));
        return prev.filter((planetId) => planetId !== id);
      } else {
          // setCookie("pro_ids", JSON.stringify([...prev, id]));
        return [...prev, id];
      }
     
    });
   
  };

  const PopoverContent = () => {
    return (
      <div className={styleSheet.popoverContent}>
        {planetDetails?.map((data: any, index: number) => (
          <div
            key={index}
            className={`d-flex py-2 pointer ${styleSheet.popoverItem} ${
              selectedPlanets.includes(data.pro_id)
                ? "opacity-100"
                : "opacity-50"
            }`}
            onClick={() => onClickPlanet(data.pro_id)}
          >
            <div className="col-2 ">
              <img
                className={`${styleSheet.image} rounded-circle`}
                src={data?.category_image}
              />
            </div>
            <div className="col-8 ">
              <span className="mohave">{data.pro_name}</span>
            </div>
            <div className="col-2 ">
              {selectedPlanets.includes(data.pro_id) && (
                <div>
                  <SyIcon
                    name={"task_alt"}
                    iconColor="green"
                    size="sm"
                    className={" pointer font-15"}
                  />
                </div>
              )}
            </div>
          </div>
        ))}
      </div>
    );
  };

  return (
    <div className={`${styleSheet.com_div} rounded-4 `}>
      <div
        className={`d-flex ${styleSheet.com_tabs} pt-2 border-start-0 border-end-0 border-top-0`}
      >
        {visibleTabs.map((tab: any) => {
          return (
            <p
              role={"button"}
              className={`${
                view === tab.id ? styleSheet.selected_tab : "text-white"
              } mx-2 mb-0 mohave-bold ellipsis `}
              onClick={() => onTabClick(tab.id)}
            >
              {t(tab.value)}
            </p>
          );
        })}
      </div>
      <div className={`pt-3  ${styleSheet.content} position-relative  `}>
        <div
          ref={scrollRef}
          className={` ${styleSheet.sub_content} sy-scroll-x sy-scroll-y`}
        >
          {view === 1 ? (
            <Comments commentData={commentData} comment={comment} />
          ) : view === 2 ? (
            <FilesList fileData={fileData} deleteDoc={deleteDoc} />
          ) : (
            <CitizensList
              citizensData={citizensData}
              deleteCitizen={deleteCitizen}
            />
          )}
        </div>
        <div className="position-absolute bottom-0 w-100 p-2 pb-3">
          {view === 1 && (
            <div className="d-flex align-items-center">
              <OrbInput
                ref={commentInputRef}
                type={"text"}
                withIcon={true}
                inputType="outlined"
                iconStyle="outlined"
                iconName={"send"}
                iconType="symbols"
                showError={false}
                onClick={onClickSend}
                iconTip="send"
                id={"comment"}
                keyClick={"Enter"}
                onClickEnter={onClickSend}
              />
              {comment && (
                <>
                  <span
                    ref={languageRef}
                    id={languageId}
                    onClick={handleOpenPopOver}
                    className=" px-2 py-1 pointer bg-white rounded ms-2 position-relative"
                  >
                    @{" "}
                    <span className="position-absolute top-0 start-100 translate-middle badge rounded-pill bg-secondary font-10">
                      {selectedPlanets.length}
                    </span>
                  </span>

                  <OrbPopover
                    open={openPopOver}
                    anchorTarget={languageRef.current}
                    id={languageId}
                    onClose={handleClosePopover}
                  >
                    <PopoverContent />
                  </OrbPopover>
                </>
              )}
            </div>
          )}
          {view === 2 && (
            <>
              <OrbInput
                type="file"
                ref={inputRef}
                className="d-none"
                onChange={fileValueChange}
              />
              <div className="d-flex justify-content-end">
                <SyIcon
                  name={"add"}
                  className={"text-white pointer "}
                  onClick={openFile}
                />
              </div>
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default FilesCommentsManage;
